<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3">
        <p class="title primary--text">SIGNIN</p>
        <div class="grey lighten-5 pa-5">
          <AAlert :alert="alert"></AAlert>
          <v-form @submit.prevent="submit" ref="form" lazy-validation>
            <v-text-field
              outlined
              v-model="username"
              label="Username"
              :rules="usernameRules"
              :disabled="loading"
            ></v-text-field>
            <v-text-field
              outlined
              :type="'password'"
              v-model="password"
              label="Password"
              :rules="passwordRules"
              :disabled="loading"
            ></v-text-field>
            <v-btn
              depressed
              type="submit"
              color="blue"
              class="white--text"
              :loading="loading"
              :disabled="loading"
            >Signin</v-btn>
          </v-form>
          <v-btn
            text
            @click="$router.push('/recovery')"
            color="primary"
            class="mt-4"
          >Forgot Password? Reset via email</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { setTimeout } from "timers";
import snackbar from "../mixins/snackbar";
import AAlert from "../components/AAlert";
import authApi from "../api/auth";
import { utils as routerUtils } from "../router";

export default {
  name: "signin",
  mixins: [snackbar],
  components: {
    AAlert
  },
  data: () => ({
    valid: true,
    username: "",
    usernameRules: [
      v => !!v || "Name is required",
      v => (v && v.length > 4) || "Name must be atleast 5 characters"
    ],
    password: "",
    passwordRules: [v => !!v || "Password is required"],
    loading: false,
    alert: {}
  }),
  async mounted() {
    this.loading = true;
    await routerUtils.setUserStatus();
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("/");
      return;
    }
    this.loading = false;
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.alertMessage = "";
        this.alertType = "success";
        authApi.signin(this.username, this.password, data => {
          this.loading = false;
          this.alert = data;
          if (data.ok) {
            if (data.d) {
              this.$store.commit("user/set", data.d.user);
            }
            this.$router.push("/cart/scan");
          }
        });
      }
    }
  }
};
</script>
